<template>
  <div id="search">
    

    <div class="header">
      <div class="meta">
        <h1 class="title">{{ title }}</h1>
      </div>
      <div class="filter">
        <LangSelector v-if="market === 'ES' && uniqueLang" :unique="uniqueLang"></LangSelector>
      </div>
      
    </div>

    <FileList :search.sync="search" :col="5" @uniqueLang="setUniqueLang"></FileList>

  </div>
</template>

<script>
import i18n from '@/i18n'
import FileList from '@/components/domain/files/FileList'
import LangSelector from '@/components/ui/LangSelector'

export default {
  name: 'Search',
  components: { FileList, LangSelector },
  data () {
    return {
      title: i18n.t('general.search_title'),
      uniqueLang: false
    }
  },
  computed: {

    lang() {
      return this.$store.state.languages;
    },
    language() {
      return this.$store.state.language;
    },
    search() {
      //return (this.s)? this.s : this.$store.state.search;
      return this.$route.query.s;
    },
    market() {
      return this.$store.getters.getMarket;
    }
  },
  methods: {
    selectLang(lang) {
      this.$store.commit('setLanguage', lang.id);
    },
    setUniqueLang(value) {
      this.uniqueLang = value;
    }
  },
  created() {
    this.$store.commit('files/setCurrentFile', false);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .header {
    position: relative;

    .title {
      margin-top: 50px;
    }

    .filter {
      position: absolute;
      top: 50px;
      right: 10px;
      z-index: 10;

      .search {
        margin: 0 auto;
        max-width: 500px;
        margin-top: 20px;
      }
    }
  }


</style>
